/**
 * dev-ops-aware-admin-api-green
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2024-11-01T00:28:25Z
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * A company group to add
 */
export interface CompanyGroupToAdd { 
    /**
     * A short description of the company group
     */
    description: string;
    /**
     * The name of the company group.
     */
    name: string;
}
